import { Http } from '@/lib/http';

export class ForeclosureLoansService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/foreclosure-loans/';
  }

  getAssigneeForeclosureCases(filters) {
    return this.httpClient().post(`${this.endpoint}workload`, filters);
  }

  calculateCashRealizedValue(collateralIds) {
    return this.httpClient().patch(
      `${this.endpoint}calculate-cash-realizable-value`,
      collateralIds
    );
  }

  updateAssets() {
    return this.httpClient().get(`${this.endpoint}update-assets`);
  }

  getForeclosureListing(params) {
    return this.httpClient().post(`${this.endpoint}`, params);
  }

  deAssignForeclosureCase({ assignmentId, deassignerId }) {
    return this.httpClient().patch(
      `${this.endpoint}foreclosure-case/deassign/${assignmentId}/${deassignerId}`
    );
  }

  /**
   * This updates the foreclosure case status
   */
  updateForeclosureCase(caseId, data) {
    return this.httpClient().patch(
      `${this.endpoint}foreclosure-case/${caseId}`,
      data
    );
  }

  /**
   * 1
   *
   * This should be used when assigning the asset/collateral to a Bailiff or Collector for the first time.
   *
   * Use this to update the status to `Bailiff, Collector, Legal, Pending Asset Registration, Asset Registered, Asset Sold`
   *
   */
  updateForeclosureStatusCollateral(collateralId, data) {
    return this.httpClient().patch(
      `${this.endpoint}update-status/${collateralId}`,
      data
    );
  }

  createForeClosureCase(data) {
    return this.httpClient().post(`${this.endpoint}foreclosure-case`, data);
  }

  findForeClosureCasesByLoanIdOrCaseId(id) {
    return this.httpClient().get(`${this.endpoint}foreclosure-case/${id}`);
  }

  assignForeclosureCase({ caseId, assigneeId, assignerId }) {
    return this.httpClient().patch(
      `${this.endpoint}foreclosure-case/assign/${caseId}/${assigneeId}/${assignerId}`
    );
  }

  getPledgedAssetsByBorrower(borrowerId, loanId) {
    return this.httpClient().get(
      `${this.endpoint}get-pledged-assets/${borrowerId}/${loanId}`
    );
  }

  removeCollateralFromForeclosureList(collateralId, data) {
    return this.httpClient().patch(
      `${this.endpoint}remove-asset/${collateralId}`,
      data
    );
  }

  addCollateralToForeclosureList(collateralId, data) {
    return this.httpClient().patch(
      `${this.endpoint}add-asset/${collateralId}`,
      data
    );
  }

  updateCollateralSaleInformation(id, data) {
    return this.httpClient().patch(
      `${this.endpoint}asset-sold-information/${id}`,
      data
    );
  }
}
